import { apiClient, UNLOCK } from '../../../shared/api';

export const requestUnlock = async (email) => {
  const requestBody = {
    user: {
      email,
    },
  };

  await apiClient.post(UNLOCK, requestBody);
};

export const unlock = async (unlockToken) => {
  const params = {
    unlock_token: unlockToken,
  };

  await apiClient.get(UNLOCK, { params });
};
